import {
  Component,
  OnInit,
  Input,
  OnChanges,
  OnDestroy,
  ViewChild,
} from "@angular/core";
import { Subscription, Observable } from "rxjs";
import { FieldDataService } from "src/app/services/fieldData/field-data.service";
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";

@Component({
  selector: "app-node-alarm-info",
  templateUrl: "./node-alarm-info.component.html",
  styleUrls: ["./node-alarm-info.component.scss"],
})
export class NodeAlarmInfoComponent implements OnInit, OnChanges, OnDestroy {
  private eventsSubscription: Subscription;
  @Input() events: Observable<void>;
  @Input() componentMode: string;
  @Input() uuid: string;
  event: any;
  loading: boolean = true;
  displayedColumns: string[] = ["fecha", "lastFecha", "lastValor", "eventType"];
  dataSource: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private fieldDataService: FieldDataService) {}

  ngOnInit() {
    this.getAlarms(this.componentMode);
  }

  getAlarms(componentMode: string) {
    switch (componentMode) {
      case "source":
        this.eventsSubscription = this.events.subscribe((data) => {
          this.event = data;
          this.fieldDataService
            .getNodeAlarmsDetail(this.event.entradas.map((r) => r.uuid))
            .subscribe(({ data, loading }) => {
              this.dataSource = new MatTableDataSource(
                data.getNodeAlarmsDetail
              );
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.loading = loading;
            });
        });
        break;
      case "entrada":
        this.eventsSubscription = this.events.subscribe((data) => {
          this.event = data;
          this.fieldDataService
            .getNodeAlarmsDetail(this.event.uuid)
            .subscribe(({ data, loading }) => {
              this.dataSource = new MatTableDataSource(
                data.getNodeAlarmsDetail
              );
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;
              this.loading = loading;
            });
        });
        break;
      case "dato":
        this.eventsSubscription = this.fieldDataService
          .getNodeAlarmsDetail([this.uuid])
          .subscribe(({ data, loading }) => {
            this.dataSource = new MatTableDataSource(data.getNodeAlarmsDetail);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.loading = loading;
          });
        break;
    }
  }

  ngOnChanges() {}
  ngOnDestroy() {}
}
